module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/client/my-settings/bank-accounts/update-bank-account/update-bank-account.component.scss
// module id = ./src/app/pages/client/my-settings/bank-accounts/update-bank-account/update-bank-account.component.scss
// module chunks = main